(function () {
  // ======================================================================
  // DISPONIBILITA' NEI NEGOZI — scheda prodotto
  // ----------------------------------------------------------------------
  // Il pannello si disegna dal solo metafield, che contiene gia' i nomi.
  // pq-sedi.json — 73 kB con coordinate e indirizzi — si scarica SOLO
  // all'apertura del popup: su una PDP che nessuno apre sarebbe peso
  // sprecato.
  //
  // Il ponte fra i due dati e' location_id nel metafield e sl nel file
  // delle sedi. Il primo e' un numero, il secondo una stringa: il
  // confronto va fatto normalizzando, altrimenti non combacia mai.
  // ======================================================================

  var root = document.querySelector('[data-pq-stock]');
  if (!root || root.dataset.pqOn) return;
  root.dataset.pqOn = '1';

  var datiEl = document.querySelector('[data-pq-stock-dati]');
  if (!datiEl) return;

  var stock = {};
  try {
    stock = JSON.parse(datiEl.textContent);
  } catch (e) {
    return;
  }

  var elConta = root.querySelector('[data-pq-ss-conta]');
  var elLista = root.querySelector('[data-pq-ss-lista]');
  var elApri = root.querySelector('[data-pq-ss-apri]');
  var overlay = document.querySelector('[data-pq-ss-overlay]');
  var elMappa = overlay.querySelector('[data-pq-ss-mappa]');
  var elPLista = overlay.querySelector('[data-pq-ss-plista]');
  var elTitolo = overlay.querySelector('[data-pq-ss-titolo]') ||
                 overlay.querySelector('.pq-ss__panel-title');

  var sedi = null;
  var mappa = null;
  var info = null;
  var marcatori = [];
  var MARCHIO = 'https://cdn.shopify.com/s/files/1/0616/7258/7444/files/favicon-black.png?v=1789475083';

  // LE SEDI COLLOCABILI, con le coordinate.
  // Stanno qui e non si ricavano da pq-sedi.json perche' quel file pesa
  // 75 kB: scaricarlo su ogni scheda prodotto solo per ordinare due nomi
  // sarebbe sproporzionato. Il file si carica all'apertura del popup,
  // dove servono indirizzi e orari.
  //
  // DA AGGIORNARE all'apertura di una boutique nuova: finche' il suo id
  // non e' qui, il riquadro la ignora.
  var SEDI_MAPPA = {
    '119565582684': { lt: 40.83641, lg: 14.24048 },
    '119565844828': { lt: 41.8521, lg: 12.57236 },
    '119565910364': { lt: 41.86517, lg: 12.49637 },
    '119565943132': { lt: 45.47161, lg: 9.19511 },
    '119565975900': { lt: 45.44308, lg: 10.99724 },
    '119566041436': { lt: 42.46984, lg: 14.20721 },
    '119566074204': { lt: 45.4642, lg: 9.18998 },
    '119566172508': { lt: 41.97129, lg: 12.54012 },
    '119566205276': { lt: 41.12579, lg: 16.86948 },
    '119566270812': { lt: 45.4364, lg: 12.33744 },
    '119566303580': { lt: 45.07034, lg: 7.68686 },
    '119566336348': { lt: 44.49333, lg: 11.34372 },
    '119566401884': { lt: 45.46671, lg: 9.18406 },
    '119566467420': { lt: 43.95796, lg: 10.16728 },
    '119566500188': { lt: 45.48472, lg: 9.20284 }
  };

  function mappabile(l) {
    return !!SEDI_MAPPA[String(l.location_id)];
  }

  // --------------------------------------------------------------------
  // LA POSIZIONE DELL'UTENTE serve a mostrare i due negozi piu' vicini
  // invece dei primi due in ordine alfabetico.
  //
  // Si chiede UNA VOLTA per sessione e si conserva in sessionStorage:
  // senza, il permesso verrebbe richiesto a ogni scheda prodotto — e un
  // avviso che ricompare a ogni pagina e' il modo piu' rapido per farlo
  // negare.
  //
  // Se l'utente rifiuta, o il browser non la espone, l'ordine resta
  // alfabetico: il pannello funziona comunque.
  // --------------------------------------------------------------------
  var CHIAVE_POS = 'pqPosizione';
  var posizione = null;

  try {
    var salvata = sessionStorage.getItem(CHIAVE_POS);
    if (salvata) posizione = JSON.parse(salvata);
  } catch (e) {
    posizione = null;
  }

  function chiediPosizione() {
    if (posizione || !navigator.geolocation) return;
    // Il flag impedisce di richiedere di nuovo dopo un rifiuto: il
    // browser mostrerebbe l'avviso a ogni caricamento.
    try {
      if (sessionStorage.getItem(CHIAVE_POS + 'No')) return;
    } catch (e) {}

    navigator.geolocation.getCurrentPosition(
      function (p) {
        posizione = { lt: p.coords.latitude, lg: p.coords.longitude };
        try { sessionStorage.setItem(CHIAVE_POS, JSON.stringify(posizione)); } catch (e) {}
        disegna();
      },
      function () {
        try { sessionStorage.setItem(CHIAVE_POS + 'No', '1'); } catch (e) {}
      },
      { timeout: 8000, maximumAge: 600000 }
    );
  }

  function distanza(lat1, lng1, lat2, lng2) {
    var R = 6371;
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLng = (lng2 - lng1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function conDistanza(elenco) {
    if (!posizione) return elenco;
    return elenco.map(function (l) {
      var c = SEDI_MAPPA[String(l.location_id)];
      l._d = c ? distanza(posizione.lt, posizione.lg, c.lt, c.lg) : Infinity;
      return l;
    }).sort(function (a, b) { return a._d - b._d; });
  }

  // LE DICITURE dai locale, passate in attributi data dallo snippet.
  // Il secondo argomento e' il ripiego: se una chiave manca nel file di
  // lingua, il pannello resta leggibile invece di mostrare una stringa
  // vuota.
  function t(chiave, ripiego) {
    var v = root.getAttribute('data-t-' + chiave);
    return v && v.indexOf('Translation missing') === -1 ? v : ripiego;
  }

  function escapa(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // --------------------------------------------------------------------
  // I NEGOZI DI UNA VARIANTE.
  // I magazzini si escludono: type "warehouse" e' la giacenza online, non
  // un posto dove si puo' andare.
  // L'ordinamento mette le boutique prima degli outlet e poi alfabetico:
  // senza la posizione dell'utente non c'e' un criterio di prossimita', e
  // un ordine casuale farebbe sembrare l'elenco incompleto.
  // --------------------------------------------------------------------
  // LA GIACENZA ONLINE decide l'etichetta: se c'e', il prodotto si
  // compra online e i negozi sono un'alternativa — quindi "anche in
  // store". Se e' a zero, i negozi sono l'unico modo di averlo — quindi
  // "solo in store".
  // Online = magazzini (l'HQ e SNATT) piu' le sedi che evadono gli ordini
  // online (fulfills_online_orders, ship from store): e' lo stesso criterio
  // con cui Shopify rende acquistabile la variante. Contando i soli
  // magazzini, una variante venduta online dalle boutique risultava "solo
  // in store" col carrello attivo (CA6592B2BM-CU4, 26/10).
  // StoreStock 2026-10-26: se il tema emette la disponibilita' di Shopify per variante (data-pq-stock-online,
  // variant.available) vale quella; il calcolo dalle sedi resta come ripiego.
  var onlineShopify = null;
  try {
    var elOnline = document.querySelector('[data-pq-stock-online]');
    if (elOnline) onlineShopify = JSON.parse(elOnline.textContent);
  } catch (e) { onlineShopify = null; }
  function scortaOnline(idVariante) {
    if (onlineShopify && Object.prototype.hasOwnProperty.call(onlineShopify, String(idVariante))) {
      return onlineShopify[String(idVariante)] ? 1 : 0;
    }
    var d = stock[String(idVariante)];
    if (!d || !d.locations) return 0;
    return d.locations.reduce(function (t, l) {
      return (l.type === 'warehouse' || l.fulfills_online_orders === true) ? t + (Number(l.qty) || 0) : t;
    }, 0);
  }

  // IL LIVELLO DI GIACENZA del negozio: dicitura e pallino accanto al
  // nome. 1 pezzo = ultimo (rosso), 2-4 = ultimi pezzi (arancio). Oltre 4
  // non si mostra nulla: la disponibilita' normale non ha bisogno di
  // un'etichetta. La quantita' esatta non si mostra mai.
  function livello(l) {
    var q = Number(l.qty) || 0;
    if (q > 4) return '';
    var k = q <= 1 ? 'uno' : 'pochi';
    var testo = k === 'uno' ? t('ultimo', 'Ultimo pezzo') : t('pochi', 'Ultimi pezzi');
    return '<span class="pq-ss__lvl pq-ss__lvl--' + k + '">' +
           '<span class="pq-ss__dot" aria-hidden="true"></span>' + escapa(testo) +
           '</span>';
  }

  function negoziDi(idVariante) {
    var d = stock[String(idVariante)];
    if (!d || !d.locations) return [];
    return d.locations
      .filter(function (l) {
        return l.type !== 'warehouse' && Number(l.qty) > 0;
      })
      .sort(function (a, b) {
        if (a.type !== b.type) return a.type === 'boutique' ? -1 : 1;
        return String(a.name).localeCompare(String(b.name));
      });
  }

  // Il nome nel metafield contiene forme interne — "Piquadro SpA – Bari",
  // "Piquadro Verona Pza delle Erbe" — che in pagina si leggono male.
  function nomePulito(n) {
    return String(n || '')
      .replace(/\s*S\.?p\.?A\.?\s*[–-]\s*/i, ' ')
      .replace(/\bPza\b/i, 'Piazza')
      .replace(/\bSt\.\s*/i, 'Stazione ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function disegna() {
    var id = root.getAttribute('data-corrente');
    var negozi = negoziDi(id);

    // NON si esce quando l'elenco dei negozi e' vuoto: il caso "solo
    // online" ha zero negozi ma giacenza a magazzino, e uscendo qui non
    // veniva mai raggiunto.
    // La decisione di nascondere il pannello sta piu' avanti, dopo aver
    // guardato anche la scorta online.
    root.hidden = false;

    // Solo i negozi COLLOCABILI si elencano: uno senza posizione non si
    // puo' raggiungere, e nominarlo lascerebbe l'utente senza sapere dove
    // andare.
    var visibili = conDistanza(negozi.filter(mappabile));

    if (!visibili.length) {
      // Nessun negozio raggiungibile. Se c'e' giacenza a magazzino si
      // dichiara che il prodotto e' solo online: senza, chi cerca
      // l'acquisto in boutique resta a chiedersi se il dato manca o se il
      // prodotto non c'e'.
      // Se non c'e' nemmeno quella, il pannello sparisce: un prodotto
      // esaurito ovunque non ha bisogno di un riquadro che lo ripeta.
      if (scortaOnline(id) > 0) {
        elConta.textContent = t('online', 'Disponibile solo online');
        elLista.innerHTML = '';
        elApri.hidden = true;
        root.classList.add('pq-ss--online');
        root.classList.remove('pq-ss--solo');
        return;
      }
      root.hidden = true;
      return;
    }

    root.classList.remove('pq-ss--online');

    // L'etichetta dipende dalla giacenza a MAGAZZINO, non dai negozi.
    var online = scortaOnline(id) > 0;
    elConta.textContent = online
      ? t('anche', 'Disponibile anche in store')
      : t('solo', 'Disponibile solo in store');
    root.classList.toggle('pq-ss--solo', !online);

    // Due soli in pagina: l'elenco completo sta nel popup, e qui serve
    // dire che il prodotto c'e' — non dove esattamente.
    elLista.innerHTML = visibili.slice(0, 2).map(function (l) {
      var d = (posizione && l._d != null && l._d !== Infinity)
        ? '<span class="pq-ss__dist">' +
          (l._d < 1 ? Math.round(l._d * 1000) + ' m' : Math.round(l._d) + ' km') +
          '</span>'
        : '';
      return '<li class="pq-ss__item">' +
             '<span class="pq-ss__name">' + escapa(nomePulito(l.name)) + livello(l) + '</span>' + d +
             '</li>';
    }).join('');

    elApri.hidden = false;
    // La dicitura con il numero usa un segnaposto: in tedesco e francese
    // la cifra non sta nella stessa posizione che in italiano.
    elApri.textContent = visibili.length > 2
      ? t('tutti', 'Vedi tutti i {{ n }} negozi').replace('{{ n }}', visibili.length)
      : t('mappa', 'Vedi sulla mappa');
  }

  // --------------------------------------------------------------------
  // IL POPUP
  // --------------------------------------------------------------------
  function caricaSedi() {
    if (sedi) return Promise.resolve(sedi);
    return fetch(root.getAttribute('data-sedi'))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        // Indice per id sede: il confronto avviene su stringa perche' nel
        // metafield location_id e' un numero e in pq-sedi.json sl e' una
        // stringa.
        sedi = {};
        (d.s || []).forEach(function (s) {
          if (s.sl) sedi[String(s.sl)] = s;
        });
        return sedi;
      });
  }

  function caricaMaps() {
    var chiave = root.getAttribute('data-maps-key');
    if (typeof google !== 'undefined' && google.maps) return Promise.resolve();
    if (!chiave) return Promise.reject();
    if (window.pqMapsPromessa) return window.pqMapsPromessa;

    window.pqMapsPromessa = new Promise(function (ok) {
      window.pqMapsPronta = function () { ok(); };
      var sc = document.createElement('script');
      sc.src = 'https://maps.googleapis.com/maps/api/js?key=' + chiave +
               '&callback=pqMapsPronta&loading=async';
      sc.async = true;
      document.head.appendChild(sc);
    });
    return window.pqMapsPromessa;
  }

    // Il contenuto della finestra informativa: stessa struttura delle
  // schede nell'elenco, cosi' passando dalla mappa alla lista non si
  // cambia alfabeto.
  function contenutoInfo(l, s) {
    var p = ['<span class="pq-ss__info-badge">' +
             escapa(l.type === 'outlet' ? t('outlet', 'Outlet Piquadro') : t('boutique', 'Boutique Piquadro')) +
             '</span>'];
    p.push('<h4 class="pq-ss__info-name">' + escapa(nomePulito(l.name)) + '</h4>');

    var ind = [s.a, s.a2].filter(Boolean).join(', ');
    var loc = [s.z, s.c].filter(Boolean).join(' ');
    p.push('<p class="pq-ss__info-addr">' + escapa(ind) +
           (loc ? '<br>' + escapa(loc) : '') + '</p>');

    if (s.h) p.push('<p class="pq-ss__info-hours">' + escapa(s.h) + '</p>');

    var az = [];
    if (s.t) {
      az.push('<a href="tel:' + s.t.replace(/[^0-9+]/g, '') + '">' + escapa(s.t) + '</a>');
    }
    az.push('<a target="_blank" rel="noopener" href="https://www.google.com/maps/dir/?api=1&destination=' +
            s.lt + ',' + s.lg + '">' + escapa(t('indicazioni', 'Indicazioni')) + '</a>');
    p.push('<div class="pq-ss__info-actions">' + az.join('') + '</div>');

    return '<div class="pq-ss__info">' + p.join('') + '</div>';
  }
  function schedaPopup(l, s) {
    var ind = s ? [s.a, s.a2].filter(Boolean).join(', ') : '';
    var loc = s ? [s.z, s.c].filter(Boolean).join(' ') : '';
    var p = ['<span class="pq-ss__badge">' +
             escapa(l.type === 'outlet' ? t('outlet', 'Outlet Piquadro') : t('boutique', 'Boutique Piquadro')) +
             '</span>'];
    p.push('<h3 class="pq-ss__pname">' + escapa(nomePulito(l.name)) + '</h3>');
    var lv = livello(l);
    if (lv) p.push('<p class="pq-ss__plvl">' + lv + '</p>');
    if (ind) {
      p.push('<p class="pq-ss__paddr">' + escapa(ind) +
             (loc ? '<br>' + escapa(loc) : '') + '</p>');
    }
    if (s && s.h) p.push('<p class="pq-ss__phours">' + escapa(s.h) + '</p>');

    var az = [];
    if (s && s.t) {
      az.push('<a href="tel:' + s.t.replace(/[^0-9+]/g, '') + '">' + escapa(s.t) + '</a>');
    }
    if (s) {
      az.push('<a target="_blank" rel="noopener" href="https://www.google.com/maps/dir/?api=1&destination=' +
              s.lt + ',' + s.lg + '">' + escapa(t('indicazioni', 'Indicazioni')) + '</a>');
    }
    if (az.length) p.push('<div class="pq-ss__pactions">' + az.join('') + '</div>');
    return p.join('');
  }

  function riempiPopup(negozi) {
    elPLista.innerHTML = '';
    var conCoord = [];

    negozi.forEach(function (l) {
      var s = sedi ? sedi[String(l.location_id)] : null;
      var li = document.createElement('li');
      li.className = 'pq-ss__pcard';
      li.innerHTML = schedaPopup(l, s);
      if (s) {
        conCoord.push({ l: l, s: s });
        li.addEventListener('click', function () { vaiA(s, li); });
      } else {
        // Non dovrebbe accadere — l'elenco e' gia' filtrato sui
        // mappabili — ma se il file delle sedi e' piu' vecchio della
        // costante la scheda resta, senza essere cliccabile.
        li.classList.add('pq-ss__pcard--nomappa');
      }
      elPLista.appendChild(li);
    });

    if (!mappa || !conCoord.length) return;

    marcatori.forEach(function (m) { m.setMap(null); });
    marcatori = [];
    var bounds = new google.maps.LatLngBounds();

    conCoord.forEach(function (x) {
      var m = new google.maps.Marker({
        position: { lat: x.s.lt, lng: x.s.lg },
        map: mappa,
        title: nomePulito(x.l.name),
        icon: {
          url: MARCHIO,
          scaledSize: new google.maps.Size(26, 26),
          anchor: new google.maps.Point(13, 13)
        }
      });
      m._s = x.s;
      m._l = x.l;
      m.addListener('click', function () {
        info.setContent(contenutoInfo(x.l, x.s));
        info.open(mappa, m);
      });
      marcatori.push(m);
      bounds.extend(m.getPosition());
    });

    if (marcatori.length === 1) {
      mappa.setCenter(marcatori[0].getPosition());
      mappa.setZoom(14);
    } else {
      mappa.fitBounds(bounds, 48);
    }
  }

  function vaiA(s, card) {
    elPLista.querySelectorAll('.pq-ss__pcard--attiva').forEach(function (c) {
      c.classList.remove('pq-ss__pcard--attiva');
    });
    if (card) card.classList.add('pq-ss__pcard--attiva');
    if (!mappa) return;
    if (mappa.getZoom() < 13) mappa.setZoom(14);
    mappa.panTo({ lat: s.lt, lng: s.lg });
    var m = marcatori.filter(function (x) { return x._s === s; })[0];
    if (m) {
      marcatori.forEach(function (x) { x.setAnimation(null); });
      m.setAnimation(google.maps.Animation.BOUNCE);
      setTimeout(function () { m.setAnimation(null); }, 1500);
      // La finestra si apre anche al click sulla SCHEDA, non solo sul
      // marcatore: chi sceglie dall'elenco si aspetta di vedere i
      // dettagli senza dover cliccare una seconda volta sulla mappa.
      if (info && m._l) {
        info.setContent(contenutoInfo(m._l, s));
        info.open(mappa, m);
      }
    }
    if (window.matchMedia('(max-width: 899px)').matches) {
      elMappa.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  var stileMappa = [
    { featureType: 'poi', stylers: [{ visibility: 'off' }] },
    { featureType: 'transit', stylers: [{ visibility: 'off' }] },
    { featureType: 'road', elementType: 'labels', stylers: [{ visibility: 'simplified' }] },
    { featureType: 'water', stylers: [{ color: '#e9e9e7' }] },
    { featureType: 'landscape', stylers: [{ color: '#f7f6f4' }] },
    { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
    { featureType: 'administrative', elementType: 'labels.text.fill', stylers: [{ color: '#8c8880' }] }
  ];

  var ultimoFuoco = null;

  function apri() {
    // LA POSIZIONE si chiede all'apertura del POPUP e non al caricamento
    // della pagina: un avviso di permesso che compare senza che l'utente
    // abbia fatto nulla viene negato quasi sempre, e il browser si ricorda
    // il rifiuto.
    // Se arriva, disegna() riordina anche il riquadro in pagina.
    chiediPosizione();
    var negozi = conDistanza(negoziDi(root.getAttribute('data-corrente')).filter(mappabile));
    if (!negozi.length) return;

    ultimoFuoco = document.activeElement;
    elTitolo.textContent = negozi.length === 1
      ? t('titolo-uno', 'Disponibile in 1 negozio')
      : t('titolo-molti', 'Disponibile in {{ n }} negozi').replace('{{ n }}', negozi.length);
    overlay.hidden = false;
    document.documentElement.style.overflow = 'hidden';

    caricaSedi()
      .then(function () {
        return caricaMaps().catch(function () { return null; });
      })
      .then(function () {
        if (!mappa && typeof google !== 'undefined' && google.maps) {
          info = new google.maps.InfoWindow();
          mappa = new google.maps.Map(elMappa, {
            center: { lat: 44.5, lng: 11.3 },
            zoom: 5,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            styles: stileMappa
          });
        }
        // Senza chiave la mappa non c'e' ma l'elenco si', con indirizzi e
        // indicazioni: il popup resta utile.
        if (!mappa) elMappa.hidden = true;
        riempiPopup(negozi);
      })
      .catch(function () {
        elMappa.hidden = true;
        riempiPopup(negozi);
      });

    var chiudi = overlay.querySelector('[data-pq-ss-chiudi]');
    if (chiudi) chiudi.focus();
  }

  function chiudiPopup() {
    overlay.hidden = true;
    document.documentElement.style.overflow = '';
    if (ultimoFuoco) ultimoFuoco.focus();
  }

  if (elApri) elApri.addEventListener('click', apri);

  overlay.addEventListener('click', function (e) {
    if (e.target.closest('[data-pq-ss-chiudi]') || !e.target.closest('[data-pq-ss-panel]')) {
      chiudiPopup();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) chiudiPopup();
  });

  // --------------------------------------------------------------------
  // IL CAMBIO VARIANTE.
  // Il tema non emette un evento proprio, quindi si osserva il campo
  // nascosto del form: e' l'unico punto che cambia in modo affidabile
  // qualunque sia il selettore usato.
  // --------------------------------------------------------------------
  function agganciaVariante() {
    var campo = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!campo) return;

    function aggiorna() {
      var v = campo.value;
      if (v && v !== root.getAttribute('data-corrente')) {
        root.setAttribute('data-corrente', v);
        disegna();
      }
    }
    campo.addEventListener('change', aggiorna);
    new MutationObserver(aggiorna).observe(campo, { attributes: true, attributeFilter: ['value'] });
    // Alcuni selettori scrivono il valore senza emettere eventi ne'
    // toccare l'attributo: un controllo periodico leggero copre il caso.
    setInterval(aggiorna, 700);
  }

  disegna();
  agganciaVariante();
})();
